module.exports = __webpack_public_path__ + "img/jewelry_and_necklace.93de3233.png";